export const phone = "tel:+918538966276";
export const mail = "mailto:bobbyyadav.445566@gmail.com";
